// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 736 ? "9adb6eba" : chunkId) + "." + {"199":"8814ef87e2af498a","736":"7773badf574465a0"}[chunkId] + ".js";
};